import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "pane", "title", "description"]

  switch(event) {
    const button = event.currentTarget
    this.activate(button.dataset.setupTabsTabParam || button.dataset.installTab)
  }

  activate(tabName) {
    if (!tabName) return

    this.paneTargets.forEach((pane) => {
      pane.classList.toggle("hidden", pane.id !== `install-${tabName}`)
    })

    this.buttonTargets.forEach((button) => {
      const active = button.dataset.installTab === tabName
      button.classList.toggle("border-indigo-500", active)
      button.classList.toggle("ring-1", active)
      button.classList.toggle("ring-indigo-500", active)
      button.classList.toggle("border-gray-200", !active)
    })

    const activeButton = this.buttonTargets.find((button) => button.dataset.installTab === tabName)
    if (!activeButton) return

    this.titleTarget.textContent = activeButton.dataset.installTitle || this.titleTarget.textContent
    this.descriptionTarget.textContent = activeButton.dataset.installDescription || this.descriptionTarget.textContent
  }
}
